export default function() {
	const debug = false;
	const footer = document.querySelector('footer');

	// First check, almost always true
	if (footer) {
		debug ? console.log('footer-bg-color enabled!') : false;

		// Let's find the primary <main>
		const main = document.querySelector('main');

		// Second check, almost always true
		if (main) {
			debug ? console.log('footer-bg-color: ' + 'found the main element') : false;

			// Avoid patterns within blocks generating horizontal scroll
			main.style.overflowX = 'clip';
			// Gather all <section> elements within <main>
			const sections = main.querySelectorAll('section');
			// Filter out <section> within <section> (top layer only)
			const topLevelSections = Array.from(sections).filter(section => section.parentElement === main);
			// Store the last <section> element found
			let lastSection = topLevelSections[topLevelSections.length - 1]; // Find the last <section> within <main>

			// Third check, usually true
			if (lastSection) {
				debug ? console.log('The last section found was:', lastSection) : false;

				let computedStyle = window.getComputedStyle(lastSection);

				const checkAndUpdateBackgroundColor = (retryCount = 0) => {
					if (retryCount >= 3) {
						debug ? console.log('footer-bg-color: ' + 'reached max tries, setting to white') : false;

						lastSection.style.overflow = 'visible';

						// If retryCount exceeds 5, set background color to white
						footer.style.backgroundColor = 'rgba(255,255,255,0)';
						return;
					}

					if (computedStyle.backgroundColor === 'rgba(0, 0, 0, 0)') {
						debug ? console.log('footer-bg-color: ' + 'trying again for a bg-color...') : false;

						// Trigger a layout to ensure computedStyle updates
						lastSection.style.display = 'none';
						//lastSection.offsetHeight; // Force a reflow
						lastSection.style.display = '';

						// Get the updated bg-color
						computedStyle = window.getComputedStyle(lastSection);

						// Call the function again after 500 milliseconds
						setTimeout(() => checkAndUpdateBackgroundColor(retryCount + 1), 500);
					} else {
						debug ? console.log('footer-bg-color: ' + 'bg-color found, adding to footer element') : false;

						lastSection.style.overflow = 'visible';

						// Set the bg-color
						footer.style.backgroundColor = computedStyle.backgroundColor;
					}
				};

				// Start the loop
				checkAndUpdateBackgroundColor();
			}

			debug ? console.log('One last check:', lastSection) : false;
		}
	}
}
